import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged } from 'rxjs';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getSegmentOptions } from 'src/app/shared/helpers/Drop-down-options';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { PortDetailsService } from 'src/app/shared/service/port-details/port-details.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { FormPopupComponent } from '../../request-form/pages/form-popup/form-popup.component';
import { WeatherFactorPopupComponent } from '../../request-form/pages/form-popup/weather-factor-popup/weather-factor-popup.component';
import { PeriodicPopupComponent } from '../periodic-popup/periodic-popup.component';

@Component({
  selector: 'app-periodic-form',
  templateUrl: './periodic-form.component.html',
  styleUrls: ['./periodic-form.component.scss'],
})
export class PeriodicFormComponent {
  requestForm!: FormGroup;
  formSubmitted: boolean = false;
  clientOptions = ['Eiger', 'ZeroNorth', 'Elite', 'Athena'];
  portNameSuggestions: any[] = [];
  filteredPortNames: any[] = [];
  shipyardOptions = ['TBD'];
  // typeofshipOptions = [
  //   'Bulk Carrier',
  //   'Chem Tanker',
  //   'Container',
  //   'General CArgo',
  //   'Oil Tanker',
  //   'Tanker',
  // ];
  merakiPicOptions = [
    { label: 'ALS - Alexroger', value: 'ALS' },
    { label: 'HAJ - Hancy', value: 'HAJ' },
    { label: 'HAS - Harshi', value: 'HAS' },
    { label: 'KER - Keerthana', value: 'KER' },
    { label: 'INV - Indhirani', value: 'INV' },
    { label: 'MAL - Malini', value: 'MAL' },
    { label: 'PHJ - Philomina', value: 'PHJ' },
    { label: 'PRA - Priya', value: 'PRA' },
    { label: 'RAS - Rajeswari', value: 'RAS' },
    { label: 'SAG - Santhosh', value: 'SAG' },
    { label: 'SOS - Souta Samanta ', value: 'SOS' },
    { label: 'BHY - Bhargavi', value: 'BHY' },
    { label: 'NAB - Nancy', value: 'NAB' },
    { label: 'DEKA - Deepika', value: 'DEKA' },
    { label: 'ARYA - Arbaaz', value: 'ARYA' },
    { label: 'HRIT - Hritik', value: 'HRIT' },
    { label: 'NIMA- Niharika Mahajan', value: 'NIMA' },
    { label: 'TST - Test', value: 'TST' },
  ];
  weatherSourceOptions = [
    { label: 'DTN', value: 'DTN' },
    { label: 'Storm Glass', value: 'stormglass' },
  ];
  eigerPicOptions = [
    { label: 'SAKA - Satish', value: 'SAKA' },
    { label: 'SABA - Sandokan', value: 'SABA' },
    { label: 'ROAK - Roman', value: 'ROAK' },
    { label: 'AAHA - Ahmet', value: 'AAHA' },
    { label: 'NIAL - Nikita', value: 'NIAL' },
    // { label: 'JESH - Jeet', value: 'JESH' },
    { label: 'RAPA - Rahul', value: 'RAPA' },
    { label: 'AHKM - Abhishek', value: 'AHKM' },
    { label: 'SAMH - Sadique Muhammad', value: 'SAMH' },
    { label: 'ALYI - Alex', value: 'ALYI' },
    { label: 'KHGL - Khazar Guliyev', value: 'KHGL' },
  ];
  segmentOptions: { value: string; label: string }[] = [];
  typeOfSpeedOptions = [
    { label: 'Constant Speed', value: 'CP Speed' },
    {
      label: 'Optimal Speed(Reefer container)',
      value: 'Optimal Speed(Reefer container)',
    },
    { label: 'Optimal Speed', value: 'Optimal Speed' },
  ];
  typeofshipOptions = [
    { label: 'Bulk carrier', value: 'Bulk carrier' },
    { label: 'Container ship', value: 'Container ship' },
    { label: 'General cargo', value: 'General cargo' },
    { label: 'Passenger ship', value: 'Passenger ship' },
    { label: 'Tanker', value: 'Tanker' },
    { label: 'Gas Tanker', value: 'Gas Tanker' },
  ];
  segmentMapping: { [key: string]: { label: string; value: string }[] } = {
    'Bulk carrier': [
      { label: 'Coaster', value: 'Coaster' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'Handymax', value: 'Handymax' },
      { label: 'Supramax', value: 'Supramax' },
      { label: 'Ultramax', value: 'Ultramax' },
      { label: 'Panamax', value: 'Panamax' },
      { label: 'Kamsarmax', value: 'Kamsarmax' },
      { label: 'post-Panamax', value: 'post-Panamax' },
      { label: 'Capesize', value: 'Capesize' },
      { label: 'Very Large Ore Carrier', value: 'VLOC' },
      { label: 'Chinamax', value: 'Chinamax' },
    ],
    Tanker: [
      { label: 'Coastal', value: 'Coastal' },
      { label: 'Intermediate', value: 'Intermediate' },
      { label: 'Handytankers', value: 'Handytankers' },
      { label: 'MR2', value: 'MR2' },
      { label: 'LR1 / Panamax', value: 'LR1/Panamax' },
      { label: 'LR2 / Aframax', value: 'LR2/Aframax' },
      { label: 'LR3 / Suezmax', value: 'LR3/Suezmax' },
      { label: 'VLCC', value: 'VLCC' },
    ],
    'Gas Tanker': [
      { label: 'Coasters', value: 'Coasters' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'MGC', value: 'MGC' },
      { label: 'LGC', value: 'LGC' },
      { label: 'VLGC', value: 'VLGC' },
      { label: 'VLEC', value: 'VLEC' },
    ],
    'Container ship': [],
    'General cargo': [
      { label: 'Coaster', value: 'Coaster' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'Handymax', value: 'Handymax' },
      { label: 'Supramax', value: 'Supramax' },
      { label: 'Ultramax', value: 'Ultramax' },
      { label: 'Panamax', value: 'Panamax' },
      { label: 'Kamsarmax', value: 'Kamsarmax' },
      { label: 'post-Panamax', value: 'post-Panamax' },
      { label: 'Capesize', value: 'Capesize' },
      { label: 'Very Large Ore Carrier', value: 'VLOC' },
      { label: 'Chinamax', value: 'Chinamax' },
    ],
    'Passenger ship': [],
  };

  voyageTypeOptions = [
    { label: 'Laden', value: 'Laden' },
    { label: 'Ballast', value: 'Ballast' },
  ];
  reportTypeOptions = [
    { label: 'Mid Voyage', value: 'MID' },
    { label: 'End Voyage', value: 'END' },
  ];
  yesNo = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  weatherfactorOptions = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  yesNoDayPositive = [
    { label: 'Yes', value: 'all_day_positive' },
    { label: 'No', value: 'no' },
  ];
  duelFuelOptions = [
    { label: 'Yes', value: 'excluded' },
    { label: 'No', value: 'included' },
  ];
  adverseCurrentValue = [
    { label: 'Yes', value: 'x' },
    { label: 'No', value: 'inc' },
  ];
  yesNo3 = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
    { label: 'N/A', value: 'Not Applicable' },
  ];
  wetherCalculationOptions = [
    { label: 'BF Only', value: 'BF' },
    { label: 'DSS', value: 'DSS' },
    { label: 'SWH', value: 'SWH' },
    { label: 'SWH&DSS', value: 'SWH+DSS' },
    { label: 'Wind Wave & Swell Height', value: 'Wind Wave & Swell Height' },
  ];
  performanceCalOptions = [
    { label: 'Voyage', value: 'Voyage' },
    { label: 'Daily', value: 'Daily' },
  ];
  templetOptions = [
    { label: 'Weather Report', value: 'weather_report' },
    // { label: 'Ballast', value: 'Ballast' },
  ];
  goodWeatherPeriod = [12, 15, 18, 24];
  windBeaufort = [2, 3, 4, 5, 6];
  fuelType = ['ULSFO', 'VLSFO', 'HSFO', 'MDO', 'LNG', 'OTHERS', 'NA'];
  selectedFile!: File;
  selectedMainCPFile!: File;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  @ViewChild('fileUpload') fileUpload: ElementRef | undefined;
  datesValidator: boolean = false;
  latDir = ['N', 'S'];
  longDir = ['E', 'W'];
  id: any;
  reportGenerate: boolean = false;
  mainCpFile: boolean = false;
  dataToPass: any;
  selectedRequestformFile: any;
  previousValue: any;
  weatherFactor: boolean = false;
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private requestFormService: RequestFormService,
    private router: Router,
    private dialog: MatDialog,
    private sharedDataService: DashboardService,
  ) {
    this.requestForm = this.fb.group({
      segment: [''],
      typeOfShip: [''],
      merakiPic: ['', Validators.required],
      shipYard: [''],
      yearBuilt: [''],
      client: ['', Validators.required],
      weatherSource: ['', Validators.required],
      typeSpeed: ['', Validators.required],
      allDayPositive: [''],
      aboutSc: ['', Validators.required],
      windBeaufort: ['', Validators.required],
      windWave: ['', Validators.required],
      swellHeight: ['', Validators.required],
      significantWave: ['', Validators.required],
      adverseCurrent: ['', Validators.required],
      currentFactor: ['', Validators.required],
      weatherFactor: [''],
      periodiccurrentfactor: ['', Validators.required],
      hoursNeedToBeCon: [false],
      goodWeatherPeriod: ['', Validators.required],
      performanceCal: ['', Validators.required],
      speedMinTol: ['', Validators.required],
      speedMaxTol: ['', Validators.required],
      speedMinTolPercentage: [false],
      speedMaxTolPercentage: [false],
      consMinTol: ['', Validators.required],
      consMaxTol: ['', Validators.required],
      extrapolationMethod: ['', Validators.required],
      wetherCalculation: ['', Validators.required],

      duelFuel: ['', Validators.required],
      bfLimitDss: ['', Validators.required],
      // mainCp: ['', Validators.required],
      cpGasOil: [''],
      mainCp: ['', [this.maxWordsValidator()]],
      useNewCurrentFormula: ['NO'],
      additionalComments: [''],
      id: [''],
    });
    this.requestForm.get('client')?.valueChanges.subscribe((value) => {
      console.log('condition', this.requestForm.value);
      if (value === 'Eiger') {
        this.weatherFactor = true;
        this.requestForm.patchValue({ periodiccurrentfactor: 'NO' });
      } else {
        this.weatherFactor = false;
        this.requestForm.patchValue({ periodiccurrentfactor: 'YES' });
      }
    });
    let firstChangeHandled = false;
    //   this.requestForm.get('weatherFactor')?.valueChanges
    // .pipe(distinctUntilChanged())
    // .subscribe((value) => {

    //   const shipLengthValue = this.requestForm.get('ship_length')?.value;
    //   if (this.id && !firstChangeHandled) {
    //     firstChangeHandled = true;
    //     return;
    //   }

    //   if (!this.id) {
    //     if (value ) {
    //       this.openPopup();
    //     }
    //   }
    //   else if(this.id) {

    //     if (value) {
    //       this.openPopup();
    //     }
    //   }

    //   this.previousValue = value;
    // });

    this.segmentOptions = getSegmentOptions().map((item) => ({
      value: item,
      label: item,
    }));
  }
  openPopup() {
    const dialog = this.dialog.open(WeatherFactorPopupComponent, {
      width: '800px',
      height: '500px',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      if (result) {
        console.log(JSON.stringify(result));
        const parsedResult =
          typeof result === 'string' ? JSON.parse(result) : result;
        this.requestForm.get('ship_length')?.setValue(parsedResult.ship_length);
        this.requestForm
          .get('ship_breadth')
          ?.setValue(parsedResult.ship_breadth);
        this.requestForm
          .get('windage_area')
          ?.setValue(parsedResult.windage_area);
        this.requestForm.get('power')?.setValue(parsedResult.power);
        this.requestForm
          .get('wind_drag_coef')
          ?.setValue(parsedResult.wind_drag_coef);
        this.requestForm.get('air_density')?.setValue(parsedResult.air_density);
        this.requestForm
          .get('empirical_constant')
          ?.setValue(parsedResult.empirical_constant);
      }
    });
  }

  // ngOnInit() {
  //   this.sharedDataService.periodicRowData$.subscribe((data) => {
  //     this.id = data?.p_id;
  //     if (this.id) {
  //       this.requestForm.patchValue(data);
  //       this.requestForm.get('id')?.setValue(data?.p_id);
  //       this.requestForm.get('merakiPic')?.setValue(data.merakipic);
  //       this.requestForm.get('shipYard')?.setValue(data.shipyard);
  //       this.requestForm.get('yearBuilt')?.setValue(data.yearbuilt);
  //       this.requestForm.get('client')?.setValue(data.client);
  //       this.requestForm.get('typeOfShip')?.setValue(data.typeofship);
  //       this.requestForm.get('weatherSource')?.setValue(data.weathersource);
  //       this.requestForm.get('typeSpeed')?.setValue(data.typespeed);
  //       this.requestForm.get('allDayPositive')?.setValue(data.alldaypositive);
  //       if (data.aboutsc === true) {
  //         this.requestForm.get('aboutSc')?.setValue('YES');
  //       } else {
  //         this.requestForm.get('aboutSc')?.setValue('NO');
  //       }
  //       this.requestForm.get('windBeaufort')?.setValue(data.windbeaufort);
  //       this.requestForm.get('windWave')?.setValue(data.windwave);
  //       this.requestForm.get('swellHeight')?.setValue(data.swellheight);
  //       this.requestForm.get('significantWave')?.setValue(data.significantwave);
  //       this.requestForm.get('adverseCurrent')?.setValue(data.adversecurrent);
  //       if (data.currentfactor === true) {
  //         this.requestForm.get('currentFactor')?.setValue('YES');
  //       } else {
  //         this.requestForm.get('currentFactor')?.setValue('NO');
  //       }
  //       if (data.weatherfactor === true) {
  //         this.requestForm.get('weatherFactor')?.setValue('YES');
  //       } else {
  //         this.requestForm.get('weatherFactor')?.setValue('NO');
  //       }
  //       if (data.periodiccurrentfactor === true) {
  //         this.requestForm.get('periodiccurrentfactor')?.setValue('YES');
  //       } else {
  //         this.requestForm.get('periodiccurrentfactor')?.setValue('NO');
  //       }
  //       this.requestForm
  //         .get('hoursNeedToBeCon')
  //         ?.setValue(data.hoursneedtobecon);
  //       this.requestForm
  //         .get('goodWeatherPeriod')
  //         ?.setValue(data.goodweatherperiod);
  //       this.requestForm.get('performanceCal')?.setValue(data.performancecal);
  //       this.requestForm.get('speedMinTol')?.setValue(data.speedmintol);
  //       this.requestForm.get('speedMaxTol')?.setValue(data.speedmaxtol);
  //       this.requestForm.get('consMinTol')?.setValue(data.consmintol);
  //       this.requestForm.get('consMaxTol')?.setValue(data.consmaxtol);
  //       if (data.extrapolationmethod === true) {
  //         this.requestForm.get('extrapolationMethod')?.setValue('YES');
  //       } else {
  //         this.requestForm.get('extrapolationMethod')?.setValue('NO');
  //       }
  //       this.requestForm
  //         .get('wetherCalculation')
  //         ?.setValue(data.wethercalculation);
  //       this.requestForm.get('duelFuel')?.setValue(data.duelfuel);
  //       this.requestForm.get('bfLimitDss')?.setValue(data.bflimitdss);
  //       this.requestForm.get('cpGasOil')?.setValue(data.cpgasoil);
  //       this.requestForm.get('mainCp')?.setValue(data.maincp);
  //       this.requestForm
  //         .get('additionalComments')
  //         ?.setValue(data.additionalcomments);

  //       // if (data.hoursneedtobecon === 'false') {
  //       //   this.requestForm.get('hoursNeedToBeCon')?.setValue(false);
  //       // } else {
  //       //   this.requestForm.get('hoursNeedToBeCon')?.setValue(true);
  //       // }
  //     }
  //   });
  // }
  ngOnInit() {
    const normalizedMapping: {
      [key: string]: { label: string; value: string }[];
    } = {};
    Object.keys(this.segmentMapping).forEach((key) => {
      normalizedMapping[key.trim().toLowerCase()] = this.segmentMapping[key];
    });

    this.requestForm
      .get('typeOfShip')
      ?.valueChanges.subscribe((selectedType) => {
        const normalizedType = selectedType?.trim().toLowerCase();
        console.log('Selected Type:', selectedType);
        console.log('Segment Options:', normalizedMapping[normalizedType]);

        this.segmentOptions = normalizedMapping[normalizedType] || [];

        const currentSegment = this.requestForm.get('segment')?.value;
        const stillValid = this.segmentOptions.some(
          (opt: { value: string; label: string }) =>
            opt.value === currentSegment,
        );
        if (!stillValid) {
          this.requestForm.get('segment')?.reset();
        }
      });

    // Subscribe to incoming row data
    this.sharedDataService.periodicRowData$.subscribe((data) => {
      if (!data) return;

      this.id = data?.p_id;

      // Patch form values
      this.requestForm.patchValue({
        id: data?.p_id,
        merakiPic: data.merakipic,
        shipYard: data.shipyard,
        yearBuilt: data.yearbuilt,
        client: data.client,
        typeOfShip: data.typeofship,
        weatherSource: data.weathersource,
        typeSpeed: data.typespeed,
        allDayPositive: data.alldaypositive,
        aboutSc: data.aboutsc ? 'YES' : 'NO',
        windBeaufort: data.windbeaufort,
        windWave: data.windwave,
        swellHeight: data.swellheight,
        significantWave: data.significantwave,
        adverseCurrent: data.adversecurrent,
        currentFactor: data.currentfactor ? 'YES' : 'NO',
        weatherFactor: data.weatherfactor ? 'YES' : 'NO',
        periodiccurrentfactor: data.periodiccurrentfactor ? 'YES' : 'NO',
        hoursNeedToBeCon: data.hoursneedtobecon,
        goodWeatherPeriod: data.goodweatherperiod,
        performanceCal: data.performancecal,
        speedMinTol: data.speedmintol,
        speedMaxTol: data.speedmaxtol,
        speedMinTolPercentage: data.speedMinTolPercentage,
        speedMaxTolPercentage: data.speedMaxTolPercentage,
        consMinTol: data.consmintol,
        consMaxTol: data.consmaxtol,
        extrapolationMethod: data.extrapolationmethod ? 'YES' : 'NO',
        wetherCalculation: data.wethercalculation,
        duelFuel: data.duelfuel,
        bfLimitDss: data.bflimitdss,
        cpGasOil: data.cpgasoil,
        mainCp: data.maincp,
        useNewCurrentFormula: data.usenewcurrentformula || data.useNewCurrentFormula || this.requestForm.get('useNewCurrentFormula')?.value || 'NO',
        additionalComments: data.additionalcomments,
      });

      const normalizedType = data.typeofship?.trim().toLowerCase();
      this.segmentOptions = normalizedMapping[normalizedType] || [];

      // Set segment value safely
      this.setSegmentValue(data.typeofship, data.segment);
    });
  }

  onShipTypeChange(event: any) {
    const selectedType = event.target.value?.trim();
    const normalizedType = selectedType?.toLowerCase();

    const normalizedMapping: {
      [key: string]: { label: string; value: string }[];
    } = {};
    Object.keys(this.segmentMapping).forEach((key) => {
      normalizedMapping[key.trim().toLowerCase()] = this.segmentMapping[key];
    });

    this.segmentOptions = normalizedMapping[normalizedType] || [];

    const currentSegment = this.requestForm.get('segment')?.value;
    const stillValid = this.segmentOptions.some(
      (opt: { value: string; label: string }) => opt.value === currentSegment,
    );
    if (!stillValid) {
      this.requestForm.get('segment')?.reset();
    }
  }

  setSegmentValue(type: string, dataSegment: string) {
    const segments = this.segmentMapping[type] || [];
    const normalized = dataSegment?.toLowerCase();

    const matched = segments.find(
      (opt: { value: string; label: string }) =>
        opt.value.toLowerCase() === normalized ||
        opt.label.toLowerCase() === normalized,
    );

    if (matched) {
      this.requestForm.get('segment')?.setValue(matched.value);
    } else {
      this.requestForm.get('segment')?.setValue(dataSegment || '');
    }
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  onInputChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 30) {
      inputElement.value = currentValue.slice(0, 30);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onVoyageChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 10) {
      inputElement.value = currentValue.slice(0, 10);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    const maxLength = 4;
    if (numericValue.length > maxLength) {
      inputElement.value = numericValue.slice(0, maxLength);
    } else {
      inputElement.value = numericValue;
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  numberInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    inputElement.value = numericValue;
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  clearClick() {
    this.requestForm.reset();
    this.formSubmitted = false;
  }

  submitClick() {
    if (this.requestForm.valid) {
      console.log(this.requestForm.value);
      const jsonData = this.requestForm.value;

      this.requestFormService.submitPeriodicForm(jsonData).subscribe(
        (data) => {
          this.toastr.success(ToasterMessages.SubmitForm);
        },
        (error) => {
          this.toastr.error(error.error.text);
        },
      );
    } else {
      this.formSubmitted = true;

      const firstInvalidControl = Object.keys(this.requestForm.controls).find(
        (key) => {
          const control = this.requestForm.get(key);
          return (
            control &&
            control.invalid &&
            control.errors?.['required'] &&
            this.fieldLabels[key]
          );
        },
      );

      if (firstInvalidControl) {
        const label = this.fieldLabels[firstInvalidControl];
        this.toastr.error(`${label} is required`);

        const el = document.querySelector(
          `[formControlName="${firstInvalidControl}"]`,
        );
        if (el) {
          (el as HTMLElement).focus();
        }
      } else {
        this.toastr.info(ToasterMessages.FormValidation);
      }

      console.log(this.requestForm.value);
    }
  }
  fieldLabels: { [key: string]: string } = {
    segment: 'Segment',
    typeOfShip: 'Type of Ship',
    merakiPic: 'Meraki Pic',
    shipYard: 'Ship Yard',
    yearBuilt: 'Year Built',
    client: 'Client',
    weatherSource: 'Weather Source',
    typeSpeed: 'Type Speed',
    allDayPositive: 'All Day Positive',
    aboutSc: 'About SC',
    windBeaufort: 'Wind Beaufort',
    windWave: 'Wind Wave',
    swellHeight: 'Swell Height',
    significantWave: 'Significant Wave',
    adverseCurrent: 'Adverse Current',
    currentFactor: 'Current Factor',
    weatherFactor: 'Weather Factor',
    periodiccurrentfactor: 'Periodic Current Factor',
    hoursNeedToBeCon: 'Hours Need To Be Considered',
    goodWeatherPeriod: 'Good Weather Period',
    performanceCal: 'Performance Calculation',
    speedMinTol: 'Speed Min Tolerance',
    speedMaxTol: 'Speed Max Tolerance',
    consMinTol: 'Consumption Min Tolerance',
    consMaxTol: 'Consumption Max Tolerance',
    extrapolationMethod: 'Extrapolation Method',
    wetherCalculation: 'Weather Calculation',
    duelFuel: 'Dual Fuel',
    bfLimitDss: 'BF Limit DSS',
    cpGasOil: 'CP Gas Oil',
    mainCp: 'Main CP',
    additionalComments: 'Additional Comments',
    id: 'ID',
  };

  topClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  restrictInput(inputField: any, maxAllowed: any) {
    inputField.value = inputField.value.replace(/^0+/, '');
    if (parseInt(inputField.value) > maxAllowed) {
      inputField.value = maxAllowed;
    }
    if (inputField.value === '0' || inputField.value === '') {
      inputField.value = '00';
    }
    if (inputField.value.length === 1) {
      inputField.value = '0' + inputField.value;
    }
  }

  maxWordsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value || '';
      const words: string[] = value.trim().split(/\s+/);
      if (words.length > 1500) {
        return { maxWordsExceeded: true };
      }
      return null;
    };
  }

  uploadfile() {
    if (this.fileInput) {
      (this.fileInput.nativeElement as HTMLInputElement).click();
    }
  }
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (
        extension === 'xls' ||
        extension === 'xlsx' ||
        extension === 'xlsm' ||
        extension === 'csv'
      ) {
        this.selectedFile = file;
        this.toastr.success(ToasterMessages.FileUpload);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64File = reader.result as string;
          // Store the base64 string in local storage
          localStorage.setItem('uploadedFile', base64File);
          localStorage.setItem('uploadedFileName', file.name);
          localStorage.setItem('periodicId', this.id || '');
          if (base64File) {
            const dialogRef = this.dialog.open(PeriodicPopupComponent, {
              width: '1087px',
              height: '500px',
              disableClose: true,
              data: this.id,
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                const jsonData = this.requestForm.value;
                this.dataToPass = result;
                this.requestFormService
                  .postPeriodicForm(jsonData, this.dataToPass, [
                    this.selectedFile,
                  ])
                  .subscribe((data) => {
                    if (data) {
                      this.clearClick();
                      this.toastr.success(
                        'voyage Repot has been successfully Generated.',
                      );
                    }
                  });
              }
            });
          }
        };
      } else {
        this.toastr.warning(ToasterMessages.FileWarning);
      }
    }
  }
  tableClick() {
    this.router.navigate(['/vp-periodicReportTable']);
  }
}
